import React from 'react';
import { Box } from '@mui/material';
import MultiSelect from '../Common/MultiSelect';
import { useComplianceFilter } from './ComplianceFilterContext';

// AB#17128: an empty selection means no filter (all regions / all system managers)
const PageFilterBar = () => {
    const {
        regionDivisionIds,
        systemManagerIds,
        options,
        setRegionDivisionIds,
        setSystemManagerIds,
    } = useComplianceFilter();

    return (
        <Box sx={{ display: 'flex', gap: '24px', flexWrap: 'wrap', mb: 2 }}>
            <Box sx={{ minWidth: '240px', flex: '0 1 320px' }}>
                <MultiSelect
                    id="compliance-center-region-division"
                    label="Region / Division"
                    variant="standard"
                    width={100}
                    value={regionDivisionIds}
                    options={options.regionDivisions}
                    onChange={(e) => setRegionDivisionIds(e.target.value)}
                />
            </Box>
            <Box sx={{ minWidth: '240px', flex: '0 1 320px' }}>
                <MultiSelect
                    id="compliance-center-system-manager"
                    label="System Manager"
                    variant="standard"
                    width={100}
                    value={systemManagerIds}
                    options={options.systemManagers}
                    onChange={(e) => setSystemManagerIds(e.target.value)}
                />
            </Box>
        </Box>
    );
};

export default PageFilterBar;
